import { Card, CardBody, Col, Row } from "reactstrap";
import { ListingTypography } from "../../../../constants";
import { ListingSubTitle } from "../../../../data/uiKits/Typography";
import DescriptionList from "./DescriptionList";
import OrderList from "./OrderList";
import UnOrderList from "./UnOrderList";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const Listing = () => {
  return (
    <Col sm="12" className="listing">
      <Card>
        <CommonCardHeader title={ListingTypography} span={ListingSubTitle} />
        <CardBody>
          <Row className="g-3">
            <UnOrderList />
            <OrderList />
            <DescriptionList />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Listing;
